import { type KpiReadingRecord, request } from '@/api'

/**
 * Several KPIs' readings in one request (`GET /v1/kpis/readings?kpiIds=a,b,c`), so a list of KPI cards costs one read
 * however many KPIs it holds (issue #556, Sentry OS-PORTAL-3). The answer is keyed by KPI id; each list is what
 * `GET /v1/kpis/:kpiId/readings` gives for that KPI, newest first. A KPI the caller cannot read is missing from the
 * answer.
 */
export const kpiReadingsApi = {
    /** The readings of every KPI in `kpiIds`, keyed by KPI id, in one request. */
    batch: (kpiIds: string[]): Promise<Record<string, KpiReadingRecord[]>> =>
        request<Record<string, KpiReadingRecord[]>>(
            `/v1/kpis/readings?kpiIds=${kpiIds.map(id => encodeURIComponent(id)).join(',')}`,
        ),
}
